module.exports = __webpack_public_path__ + "img/marker_route_focused.8f87f4ca.svg";